<template>
  <InvestorOnboardingStep>
    <View direction="column" gap="lg">
      <Text variant="h2">Choose your role</Text>
      <RadioButtonGroup direction="column">
        <RadioCard name="accountType" :value="AccountType.Company" :disabled="isSaving" v-model="model">
          <View direction="row" gap="sm" align="center">
            <IconTile icon="building-06" size="small" color="yellow" />
            <View direction="column" gap="xs">
              <Text variant="label-medium">Company</Text>
              <Text variant="body-small" color="secondary">
                Invite teammates, standardize workflows, and scale your leasing ops.
              </Text>
            </View>
          </View>
        </RadioCard>
        <RadioCard name="accountType" :value="AccountType.Individual" :disabled="isSaving" v-model="model">
          <View direction="row" gap="sm" align="center">
            <IconTile icon="user-01" size="small" color="neutral" />
            <View direction="column" gap="xs">
              <Text variant="label-medium">Individual Owner</Text>
              <Text variant="body-small" color="secondary">
                Simplify showings and decisions with an AI copilot built for speed.
              </Text>
            </View>
          </View>
        </RadioCard>
      </RadioButtonGroup>

      <View justify="end" gap="sm">
        <Button variant="ghost" :disabled="isSaving" @click="goBack">Back</Button>
        <Button :disabled="!canContinue" :loading="isSaving" @click="next">Continue</Button>
      </View>
    </View>
  </InvestorOnboardingStep>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { Button, RadioButtonGroup, RadioCard, Text, View, IconTile } from '@tallo/design-system';
import {
  AccountType,
  InvestorOnboardingStep as OnboardingStep,
  useOnboardingStep,
  useOnboardingStore,
} from '@tallo/investor/investor';
import { AppRouteNames } from '@tallo/investor/navigation';

import InvestorOnboardingStep from '../components/investor-onboarding-step.vue';

const router = useRouter();
const store = useOnboardingStore();

// Local until saved: the store only ever holds what the server has
const model = ref(store.accountType);
const { goBack, isSaving, canContinue, save, onContinue } = useOnboardingStep(() => !!model.value);

async function next() {
  const accountType = model.value;
  if (!accountType) return;

  await save(async () => {
    await store.saveStep(OnboardingStep.AccountType, { accountType });
    router.push({
      name:
        accountType === AccountType.Company
          ? AppRouteNames.INVESTOR_ONBOARDING_COMPANY_INFO
          : AppRouteNames.INVESTOR_ONBOARDING_INVITE_TEAM,
    });
  }, "We couldn't save your answer. Please try again.");
}

onContinue(next);
</script>
